export default __webpack_public_path__ + "static/media/ic_time.98943c05.svg";